<template>
    <form-modal
        name="confirm-modal"
        :primary-button-text="lang('Ja, kör på','Yes, continue')"
        primary-button-class="is-primary"
        :title="lang('Bekräfta','Confirm')"
        :action="actionUrl"
        :redirect-to="redirectTo"
        @before-open="beforeOpen"
    >
        {{ lang('Är du säker','Are you sure') }}?
    </form-modal>
</template>

<script>
    export default {
        data() {
            return {
                action: '',
            };
        },
        computed: {
            actionUrl() {
                return this.action;
            },
            redirectTo() {
                return window.location.href;
            },
        },
        methods: {
            beforeOpen(event) {
                if (event.params.action) {
                    this.action = event.params.action;
                }
            },
        },
    };
</script>